import axios from "axios";
import { API } from "./api";

const TOKEN_KEY = "hbe_admin_token";

export function getAdminToken() {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}
export function setAdminToken(t) {
  localStorage.setItem(TOKEN_KEY, t);
}
export function clearAdminToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export const adminApi = axios.create({ baseURL: API });

adminApi.interceptors.request.use((config) => {
  const t = getAdminToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      clearAdminToken();
      if (
        typeof window !== "undefined" &&
        !window.location.pathname.startsWith("/admin/login")
      ) {
        window.location.replace("/admin/login");
      }
    }
    return Promise.reject(err);
  }
);
